module.exports = __webpack_public_path__ + "static/img_0736-9bf0ddedc037a1682c32a4ad741b6c73.webp";